import { createEndpointMaker } from "./sg-core/services/EndpointService";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
if (!baseUrl) { throw new Error("REACT_APP_API_BASE_URL must be defined") }

const pdfUrl = process.env.REACT_APP_PDF_GENERATOR_URL;
if (!pdfUrl) { throw new Error("REACT_APP_PDF_GENERATOR_URL must be defined") }



const GENERATED = "generated";

const makeEndpoint = createEndpointMaker(baseUrl);

export const Auth = makeEndpoint(["login_v03.aspx"]);

export const havainnot = makeEndpoint(["havainnot_v09.aspx"]);

export const auditoinnit = makeEndpoint(["auditoinnit_v02.aspx"]);
export const GeneratedAuditoinnit = makeEndpoint([GENERATED, "auditoinnit_api.aspx"]);

export const Kohteet = makeEndpoint(["kohteet_v02.aspx"]);

export const Yleiset = makeEndpoint(["yleiset_v04.aspx"]);

export const Upload6 = makeEndpoint(["upload6_v02.aspx"]);

export const Common = makeEndpoint(["yleiset_v04.aspx"]);

export const HPR = makeEndpoint(["hpr_v02.aspx"]);

export const GeneratedHpr = makeEndpoint([GENERATED, "hpr_api.aspx"]);

export const Kartta = makeEndpoint(["Kartta_v01.aspx"]);

export const Tilannekuva = makeEndpoint(["tilannekuva_v02.aspx"]);


const PDF = "pdf-generate";
const makePdfEndpoint = createEndpointMaker(pdfUrl);
export const PdfGenerate = makePdfEndpoint([PDF]);
